const checkWindowAppData = () => {
  if (!window.APP_DATA) {
    const storageAppData = localStorage.getItem('appData');
    if(storageAppData){
      window.APP_DATA = JSON.parse(storageAppData);
    }
  }
};
export default checkWindowAppData;
